import { EditorPage } from './pages/EditorPage';
import { LandingPage } from './pages/LandingPage';
import { PublicOrderPage } from './pages/PublicOrderPage';

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/app') return <EditorPage />;
  if (path === '/order') return <PublicOrderPage />;
  return <LandingPage />;
}
